<div class="sidebar-content">
    <div class="sidebar-category">
        <div class="category-title hidden-xs">
            <span><i class="fa fa-exclamation-triangle hidden"></i> {{user.username}}</span>
        </div>
        <div class="category-content">
            <form action="#">
                <div class="row search-mobile">
                    <div class="col-xs-6">
                        <div class="has-feedback has-feedback-left">
                            <input type="search" class="form-control" placeholder="Search" (keyup)="searchingType($event.target.value)" name="search">
                            <div class="form-control-feedback">
                                <i class="icon-search4 text-size-base text-muted"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="form-group">
                            <select class="form-control" data-width="100%" placeholder="Vehicle List" name="filterList" [(ngModel)]="filterList" (change)="filterChanged($event.target.value)">
                                <optgroup label="Groups">
                                    <option *ngFor="let group of vehicleGroups">{{ group }}</option>
                                </optgroup>
                                <optgroup label="Vehicle Status">
                                    <option *ngFor="let status of vehicleStatusGroups">{{ status }}</option>
                                </optgroup>
                                <optgroup label="Selected">
                                    <option value="Selected">Selected Vehicles</option>
                                </optgroup>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row search-row">
                    <div class="col-sm-12">
                        <div class="has-feedback has-feedback-left">
                            <input type="search" class="form-control" placeholder="Search" (keyup)="searchingType($event.target.value)" name="search">
                            <div class="form-control-feedback">
                                <i class="icon-search4 text-size-base text-muted"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row search-row">
                    <!-- <div class="col-xs-12" ng-class="{ 'col-xs-12': !$root.superuser, 'col-xs-6': $root.superuser }"> -->
                    <div class="col-xs-12">
                        <div class="form-group">
                            <select class="form-control" data-width="100%" placeholder="Vehicle List" name="filterList" [(ngModel)]="filterList" (change)="filterChanged($event.target.value)">
                                <optgroup label="Groups">
                                    <option *ngFor="let group of vehicleGroups">{{ group }}</option>
                                </optgroup>
                                <optgroup label="Vehicle Status">
                                    <option *ngFor="let status of vehicleStatusGroups">{{ status }}</option>
                                </optgroup>
                                <optgroup label="Selected">
                                    <option value="Selected">Selected Vehicles</option>
                                </optgroup>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12" *ngIf="showMultipleOnMap">
                        <!-- Default switch -->
                        <p class="vehicle--plate" style="float: left;">Select All Vehicles</p>
                        <label class="switch">
                          <input type="checkbox" (change)="showAllVehicles($event)">
                          <span class="slider round"></span>
                        </label>
                    </div>
                </div>
                <div class="vehicle--summary" id="scrollable-div">
                    <ul class="vehicle--summary-list vehicle--list-inline-mobile list-unstyled">
                        <li
                            *ngFor="let vehicle of listedVehicles"
                            class="DocumentItem vehicle--border-by-status {{'vehicle--'+vehicle.status}}"
                            [ngClass]="{'vehicle-hidden': !vehicle.shownOnMap}" id="{{vehicle.unitid}}">
                            <label class="switch-mini" *ngIf="showMultipleOnMap">
                              <input type="checkbox" [checked]="vehicle.toggleInfoWdw" (change)="showMapInfoWdw(vehicle, $event)">
                              <span class="slider-mini round"></span>
                            </label>
                            <div class="col-xs-9 vehicle--summary-data" (click)="toggleShownOnMap(vehicle, true)">
                                <div class="vehicle--summary-header">
                                    <span class="vehicle--status"><i class="fa" [ngClass]="{ 'fa-circle': vehicle.status == 'active'}" aria-hidden="true">
                                    {{ vehicle.status == 'idle' ? '◼' : ''}}
                                    {{ vehicle.status == 'stop' ? '▲' : ''}}
                                    {{ vehicle.status == 'off' ? '☗' : ''}}</i></span>
                                    <span class="vehicle--plate">{{vehicle.description}}</span>
                                </div>
                                <div class="vehicle--summary-body">
                                    <span class="vehicle--location" *ngIf="vehicle.menuGeocode">
                                        <a class="clickable" (click)="coordToGeocode(vehicle)">{{vehicle.location}}</a> 
                                    </span>
                                    <span class="vehicle--location" *ngIf="!vehicle.menuGeocode">
                                        {{vehicle.location}} 
                                    </span>
                                    <!-- <br> -->
                                    <small class="text-muted">{{vehicle.convertedTime}}</small>
                                </div>
                            </div>
                            <div class="col-xs-3 vehicle--icon" (click)="toggleShownOnMap(vehicle, true)">
                                <img [src]="vehicle.icon" alt="icon">
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
        </div>
    </div>
</div>